import {
  ECategoryType,
  EPredictiveCategoryType,
  ESubcategoryType,
} from "../interfaces/Products/IProductDetail";
import { IColor } from "./selectColors";

export const subcategories = [
  {
    name: "global.subcategories.all",
    value: "",
  },
  {
    name: "global.subcategories.daytrade",
    value: ESubcategoryType.daytrade,
  },
  {
    name: "global.subcategories.swingtrade",
    value: ESubcategoryType.swingtrade,
  },
  {
    name: "global.subcategories.wallets",
    value: ESubcategoryType.wallets,
  },
];

export const categories = [
  {
    name: "global.categories.all",
    value: "",
  },
  {
    name: "global.categories.copytrading",
    value: ECategoryType.CopyTrading,
  },
];

export const predictivesCategories = [
  {
    name: "global.predictives_category.all",
    value: "",
  },
  {
    name: "global.predictives_category.copom",
    value: EPredictiveCategoryType.copom,
  },
  {
    name: "global.predictives_category.dolar",
    value: EPredictiveCategoryType.dolar,
  },
  {
    name: "global.predictives_category.IBOV",
    value: EPredictiveCategoryType.IBOV,
  },
  {
    name: "global.predictives_category.acoes",
    value: EPredictiveCategoryType.acoes,
  },
];

interface ICategoryType {
  title: string;
  color: IColor;
}

export function tradutorCategory(status: ECategoryType): ICategoryType {
  const statusMap = {
    [ECategoryType.CopyTrading]: {
      color: IColor.orange,
      title: "global.categories.copytrading",
    },
  };

  const selected = statusMap[status] || {
    title: status,
    color: IColor.orange,
  };

  return {
    title: selected.title,
    color: selected.color,
  };
}

export function tradutorSubcategory(status: ESubcategoryType): ICategoryType {
  const statusMap = {
    [ESubcategoryType.daytrade]: {
      color: IColor.blue,
      title: "global.subcategories.daytrade",
    },
    [ESubcategoryType.swingtrade]: {
      color: IColor.blue,
      title: "global.subcategories.swingtrade",
    },
    [ESubcategoryType.wallets]: {
      color: IColor.blue,
      title: "global.subcategories.wallets",
    },
  };

  const selected = statusMap[status] || {
    title: status,
    color: IColor.orange,
  };

  return {
    title: selected.title,
    color: selected.color,
  };
}
